import React from "react";
import C3 from "c3";
import {
  getChartTableInfo,
  ChartSize,
  createChartTableStyle,
  drawResultsCharts,
} from "../common/chart";
import { ChartList } from "../../../../../common/constants";
import { IFileRow } from "../../../../../webapi/service/getFIles";
import "../../projectdetail.css";
import { ISimulationResultsRow } from "../../../../../webapi/service/getSimulationResults";

export interface IProps {
  /**
   * メインスペースの幅
   */
  mainSpaceWidth: number;
  /**
   * ファイル情報一覧
   */
  rows: IFileRow[];
  /**
   * シミュレーション結果
   */
  simRows: ISimulationResultsRow[];
  /**
   * チャートが選択された場合に呼び出されます
   * @param rowid - 行ID
   */
  onSelecRow: (rowid: number) => void;
  /**
   * ローディング画面の表示非表示を切り替えます
   * @param loading - ローディング画面を表示する場合はtrue
   */
  onLoading: (loading: boolean) => void;
  /**
   * ファイル一覧をロードする場合に呼び出します
   * @param loading - ローディング画面を表示する場合はtrue
   */
  onLoadFiles: (loading: boolean) => void;
}

class ResultsSimulation extends React.Component<IProps> {
  private readonly chartid_fmt = "chart_file_";
  private readonly chartid_fmt_in = "chart_file_inrows_";
  private readonly chartid_fmt_out = "chart_file_outrows_";
  private readonly DefaultChartSize: ChartSize = {
    width: ChartList.SIM_WIDTH,
    height: ChartList.SIM_HEIGHT,
  };
  private _charts: C3.ChartAPI[] | null = null;
  private _chartSize: ChartSize = this.DefaultChartSize;

  constructor(props: IProps) {
    super(props);
    this.chartSize = this.chartSize.bind(this);
  }

  chartSize(size?: ChartSize) {
    if (size) {
      this._chartSize = size;
    }
    return this._chartSize;
  }

  createCharts(): void {
    const { mainSpaceWidth } = this.props;
    const { simRows } = this.props;
    const { chartWidth, chartHeight } = getChartTableInfo(
      mainSpaceWidth,
      this.DefaultChartSize,
      true
    );
    this._charts = drawResultsCharts(
      simRows, 
      this.chartid_fmt_out,
      chartWidth,
      chartHeight,
    );
    this._charts = drawResultsCharts(
      simRows,  
      this.chartid_fmt_in,
      chartWidth,
      chartHeight,
    );
    this.chartSize({ width: chartWidth, height: chartHeight});
  }

  destroyCharts(): void {
    if (this._charts) {
      this._charts.forEach((chart) => {
        chart.destroy();
      });
      this._charts = null;
    }
  }

  componentDidMount(): void {
    this.createCharts();
  }

  componentDidUpdate(prevProps: IProps): void {
    const { onLoading, simRows } = this.props;
    if (simRows.length !== prevProps.simRows.length) {
      setTimeout(() => {
        this.destroyCharts();
        this.createCharts();
        onLoading(false);
      });
      onLoading(true);
    }
  }

  componentWillUnmount(): void {
    this.destroyCharts();
  }

  createChartList(): JSX.Element[] {
    const { simRows, onSelecRow } = this.props;
    const charts: JSX.Element[] = [];
    simRows.forEach((row, i) => {
      const id: number = row.id;
      const chartid: string = this.chartid_fmt + String(id);
      const chartid_in: string = this.chartid_fmt_in + String(id);
      const chartid_out: string = this.chartid_fmt_out + String(id);
      charts.push(
        <div className="chart-list-item" key={i}>
          <div style={{ height: "10px" , backgroundColor: "transparent"}} />
          <div id={chartid} onClick={() => onSelecRow(id)}></div>
          <div id={chartid_out} onClick={() => onSelecRow(id)}></div>
          <div id={chartid_in} onClick={() => onSelecRow(id)}></div>
        </div>
      );
    });
    return charts;
  }

  render(): JSX.Element {
    const { mainSpaceWidth } = this.props;
    const chartTableStyle = createChartTableStyle(
      mainSpaceWidth,
      this.DefaultChartSize,
      this._charts,
      this.chartSize
    );
    const contents = this.createChartList();
    return (
      <div className="chart-list-area">
        <div style={chartTableStyle}>{contents}</div>
      </div>
    );
  }
}

/**
 * シミュレータのシミュレーション結果画面
 */
export default ResultsSimulation;